
  
    <cradua-numberofapproval
        [numberofapprovals]="numberofapprovals$ | async"
        (numberofapproval)="onSubmitNumberOfApproval($event)"
        (deleteNumberOfApprovalEvent)="onDeleteNumberOfApproval($event)"
        *ngIf="(isLoading$ | async ) === false"
       
        >
  </cradua-numberofapproval>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  